import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Login from './Login';
import Nav from './Nav';
import User from './User';
import Offline from './Offline';
import logo from './images/somnonetz.png';
import dgsm from './data/dgsm.json';
import './styles/feedback.scss';


export default createReactClass({

   propTypes: {
      children: PropTypes.object,
   },

   childContextTypes: {
      username: PropTypes.string,
   },

   getDefaultProps() {
      return {
         children: null,
      };
   },

   getInitialState() {
      return {
         loggedIn: false,
         loginMessage: '',
         build: window.config.build,
      };
   },

   getChildContext() {
      const { username } = this.state;
      return { username };
   },

   componentDidMount() {
      window.xnat.on('sessionEnded', () => this.setState({
         loggedIn: false,
         loginMessage: 'Session abgelaufen',
      }));

      window.xnat.checkLogin()
         .then(loggedIn => this.setState({ loggedIn }));
   },

   handleUserChange(username) {
      this.setState({ username });
   },

   handleLogin(username, password) {
      this.setState({
         username,
         password,
         loggedIn: true,
         loginMessage: '',
      });
   },

   handleLogout() {
      this.setState({
         loggedIn: false,
         username: null,
      });
   },

   renderContent() {
      if (!this.state.loggedIn) {
         return (
            <div>
               <Login
                  onLogin={this.handleLogin}
                  message={this.state.loginMessage}
                  {...window.config.login}
               />
            </div>
         );
      }

      if (!this.props.children) {
         return <Nav username={this.state.username} password={this.state.password} onChange={this.handleLogin} />;
      }

      return this.props.children;
   },

   render() {
      return (
         <div className="wrapper">
            <header className="page-header">
               <Link to="/">
                  <img src={logo} height="29" width="235" alt="Somnonetz" />
               </Link>
               <span className="spacer" />
               {this.state.loggedIn && <User onLogout={this.handleLogout} onChange={this.handleUserChange} username={this.state.username} />}
            </header>

            <main>
               {this.renderContent()}
            </main>

            <footer className="page-footer">
               Version vom {this.state.build}
            </footer>

            <div className="feedbackForm">
               <a
                  href={`mailto:${dgsm.email}?subject=Somnonetz${this.state.username ? ` | user "${this.state.username}"` : ''}&body=Liebes%20DGSM-Team,`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="submit"
               >
                  Fehler melden
               </a>
            </div>

            <Offline />
         </div>
      );
   },

});
